<template>
    <div>
        <el-form :model="contract" ref="ruleForm" class="demo-ruleForm">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th>阶段名称</th>
                    <th v-if="contractType == integPurch.value && offline" width="140">质保起算时间</th>
                    <th width="110">绝对时间</th>
                    <th width="140">时长</th>
                    <th width="100">付款账期(<span class="font-red">天</span>)</th>
                    <th width="100">支付金额(<span class="font-red">%</span>)</th>
                    <th width="100">支付金额(<span class="font-red">元</span>)</th>
                    <th v-if="contractType == integPurch.value" width="120">商品交付件数(<span class="font-red">%</span>)</th>
                    <th v-if="contractType == integPurch.value" width="130">预计商品交付件数</th>
                    <th width="80">当前阶段</th>
                    <th width="100">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(contractTrackPhase, index) in contract.contractTrackPhaseList">
                    <td>
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.name'" :rules="{required: true, type : 'string', message: '阶段名称不能为空', trigger: 'blur'}">
                            <el-input :disabled="disabledInput(contractTrackPhase)" @blur="changeName(contractTrackPhase, index)" v-model="contractTrackPhase.name"></el-input>
                        </el-form-item>
                    </td>
                    <td v-if="contractType == integPurch.value && offline">
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.wrntPeriodStartTime'" :rules="{required: true, type : 'date', message: '请选择时间', trigger: 'change'}">
                            <el-date-picker :disabled="disabledInput(contractTrackPhase)" style="width: 120px;" v-model="contractTrackPhase.wrntPeriodStartTime" type="date" format="yyyy-MM-dd" placeholder="选择日期" :picker-options="wrntPeriodStartTimeOptions"></el-date-picker>
                        </el-form-item>
                    </td>
                    <td>
                        <el-switch :disabled="disabledInput(contractTrackPhase)" v-model="contractTrackPhase.absDate" on-color="#13ce66" off-color="#ff4949" @change="changeDueDate(contractTrackPhase)"></el-switch>
                    </td>
                    <td>
                        <div v-if="!contractTrackPhase.absDate || contractTrackPhase.absDate == 'false'">
                            <el-form-item style="width: 110px;" class="inline-block" :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.incrDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                                <el-input :disabled="disabledInput(contractTrackPhase)" v-model.number="contractTrackPhase.incrDays"></el-input>
                            </el-form-item>
                            <span>天</span>
                        </div>
                        <div v-else>
                            <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.dueDate'" :rules="{required: true, type : 'date', message: '请选择时间', trigger: 'change'}">
                                <el-date-picker :disabled="disabledInput(contractTrackPhase)" style="width: 120px;" v-model="contractTrackPhase.dueDate" type="date" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </div>
                    </td>
                    <td>
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.payDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                            <el-input :disabled="disabledInput(contractTrackPhase)" v-model.number="contractTrackPhase.payDays"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.amountPayPct'" :rules="{validator : validateNumber, trigger: 'change'}">
                            <el-input max="100" :disabled="disabledInput(contractTrackPhase)" @change="amountPayValue(contractTrackPhase)" v-model.number="contractTrackPhase.amountPayPct"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.amountPay'" :rules="{validator : validateMoneyStr, trigger: 'change'}">
                            <el-input :disabled="disabledInput(contractTrackPhase)" @change="amountPayPctValue(contractTrackPhase)" v-model.number="contractTrackPhase.amountPay"></el-input>
                        </el-form-item>
                    </td>
                    <td v-if="contractType == integPurch.value">
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.goodsDeliverCountPct'" :rules="{validator : validateNumber, trigger: 'change'}">
                            <el-input max="100" :disabled="disabledInput(contractTrackPhase)" @change="goodsDeliverCountValue(contractTrackPhase)" v-model.number="contractTrackPhase.goodsDeliverCountPct"></el-input>
                        </el-form-item>
                    </td>
                    <td v-if="contractType == integPurch.value">
                        <el-form-item :key="contractTrackPhase.id" :prop="'contractTrackPhaseList.' + index + '.goodsDeliverCount'" :rules="{validator : validateIntStr, trigger: 'change'}">
                            <el-input :disabled="disabledInput(contractTrackPhase)" @change="goodsDeliverCountPctValue(contractTrackPhase)" v-model.number="contractTrackPhase.goodsDeliverCount"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <span v-if="contractTrackPhase.ended">已结束</span>
                        <span v-if="contractTrackPhase.active">是</span>
                    </td>
                    <td>
                        <a v-if="!contractTrackPhase.ended && ((!contract.confirmed && operate != 'chakan') || (operate == 'change' && (contractTrackPhase.id == null || !contractTrackPhase.active)))" class="swb-btn-link ml10" @click="removeContractTrackPhase(index)">移除</a>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot" v-if="operate != 'chakan'">
                <tr class="row">
                    <td v-if="contractType == integPurch.value && !offline" colspan="10">
                        <a class="swb-btn-link" @click="addContractTrackPhase">+ 合同计划阶段</a>
                    </td>
                    <td v-else-if="contractType == integPurch.value && offline" colspan="11">
                        <a class="swb-btn-link" @click="addContractTrackPhase">+ 合同计划阶段</a>
                    </td>
                    <td v-else colspan="8">
                        <a class="swb-btn-link" @click="addContractTrackPhase">+ 合同计划阶段</a>
                    </td>
                </tr>
                </tfoot>
            </table>
        </el-form>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import contractApi from '../../api/contract'
    import tradeApi from '../../api/trade'

    export default {
        name: 'swb-contract-track-phase',
        desc: '合同阶段',
        props: ['contractId', 'offline', 'estmtAmount', 'estmtGoodsCount', 'contractType', 'operate'],
        watch: {
            offline: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    let contractTrackPhaseList = this.contract.contractTrackPhaseList;
                    if(contractTrackPhaseList != null && contractTrackPhaseList.length > 0) {
                        for(var i = 0; i < contractTrackPhaseList.length; i++) {
                            let trackPhase = contractTrackPhaseList[i];
                            trackPhase.wrntPeriodStartTime = null;
                        }
                    }
                    this.contract.contractTrackPhaseList = Utils.merge({}, contractTrackPhaseList);
                }
            },
            estmtAmount: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    let contract = this.contract;
                    contract.estmtAmount = newValue;
                    this.contract = Utils.merge({}, contract);
                    this.syncTrackPhaseAmountOrCount();
                }
            },
            estmtGoodsCount: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    let contract = this.contract;
                    contract.estmtGoodsCount = newValue;
                    this.contract = Utils.merge({}, contract);
                    this.syncTrackPhaseAmountOrCount();
                }
            },
            contractId: function (newValue, oldValue) {
                let contractId = this.contractId;
                if(contractId != null && this.operate != 'change') {
                    console.log("111111++++" + contractId);
                    this.getContractById(contractId);
                }
            }
        },
        data: function () {
            return {
                contract: {
                    estmtAmount: 0,
                    fstPartyConfirmed: false,
                    sndPartyConfirmed: false,
                    contractTrackPhaseList: []
                },
                rules: {},
                servcPurch: {},
                integPurch: {},
                servcDlgt: {},
                wrntPeriodStartTimeOptions: {
                    disabledDate(time) {
                        return time.getTime() < new Date('1970-1-2') || time.getTime() > new Date('2037-12-31');
                    }
                }
            }
        },
        created: function () {

            this.servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
            this.integPurch = getEnumInfoWith("contractType", 'name', 'IntegPurch');
            this.servcDlgt = getEnumInfoWith("contractType", 'name', 'ServcDlgt');

            let contractId = this.contractId;
            if(contractId != null && this.operate != 'change') {
                this.getContractById(contractId);
            }
        },
        methods: {
            validateMoneyStr: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确金额！'));
                    } else {
                        callback();
                    }
                }
            },
            validateNumber: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isNumber(value) || value > 100) {
                        callback(new Error('请输入正确数值！'));
                    } else {
                        callback();
                    }
                }
            },
            validateIntStr: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isIntStr(value)) {
                        callback(new Error('请输入正整数！'));
                    } else {
                        callback();
                    }
                }
            },
            validateIntNotNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('该属性不能为空'));
                } else {
                    if(!Utils.isIntStr(value) || value <= 0) {
                        callback(new Error('请输入正整数'));
                    } else {
                        callback();
                    }
                }
            },
            disabledInput: function (contractTrackPhase) {
                let disabled = false;
                let operate = this.operate;
                //(operate == 'change' && contractTrackPhase.id != null && contractTrackPhase.active == true) ||
                if(operate == 'chakan' || contractTrackPhase.ended == true) {
                    disabled = true;
                }
                return disabled;
            },
            syncTrackPhaseAmountOrCount: function (isTrue) {
                let contractTrackPhaseList = this.contract.contractTrackPhaseList;
                if(contractTrackPhaseList != null && contractTrackPhaseList.length > 0) {
                    for(var i = 0; i < contractTrackPhaseList.length; i++) {
                        let trackPhase = contractTrackPhaseList[i];
                        //
                        if(!Utils.isNoB(trackPhase.amountPayPct)) {
                            this.amountPayValue(trackPhase);
                        } else if(!Utils.isNoB(trackPhase.amountPay)) {
                            this.amountPayPctValue(trackPhase);
                        }
                        //
                        if(!Utils.isNoB(trackPhase.goodsDeliverCountPct)) {
                            this.goodsDeliverCountValue(trackPhase);
                        } else if(!Utils.isNoB(trackPhase.goodsDeliverCount)) {
                            this.goodsDeliverCountPctValue(trackPhase);
                        }
                    }
                }
            },
            getContractById: function (contractId) {
                let self = this;
                let offline = self.offline;
                let postData = {};
                postData.id = contractId;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        let contract = result.data;
                        let contractTrackPhaseList = contract.contractTrackPhaseList;
                        if(contractTrackPhaseList != null && contractTrackPhaseList.length > 0) {
                            for(var i = 0; i < contractTrackPhaseList.length > 0; i++) {
                                let contractTrackPhase = contractTrackPhaseList[i];
                                let absDate = contractTrackPhase.absDate;
                                if(absDate) {
                                    contractTrackPhase.dueDate = new Date(contractTrackPhase.dueDate);
                                }
                                //
                                if(offline && self.contractType == self.integPurch.value) {
                                    contractTrackPhase.wrntPeriodStartTime = new Date(contractTrackPhase.wrntPeriodStartTime);
                                }
                            }
                        }
                        self.contract = contract;
                    }
                });
            },
            addContractTrackPhase: function () {
                let self = this;
                let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                let contractTrackPhase = {};
                contractTrackPhase.id = null;
                contractTrackPhase.name = null;
                contractTrackPhase.absDate = false;
                contractTrackPhase.incrDays = null;
                contractTrackPhase.dueDate = null;
                contractTrackPhase.wrntPeriodStartTime = null;
                contractTrackPhase.amountPayPct = null;
                contractTrackPhase.goodsDeliverCountPct = null;
                contractTrackPhase.active = false;
                contractTrackPhase.ended = false;
                if(contractTrackPhaseList.length == 0) {
                    contractTrackPhase.active = true;
                }
                contractTrackPhaseList.push(contractTrackPhase);
                self.contract.contractTrackPhaseList = Utils.merge([], contractTrackPhaseList);
            },
            removeContractTrackPhase: function (index) {
                let self = this;
                let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                let contractTrackPhase = Utils.merge({}, contractTrackPhaseList[index]);
                contractTrackPhaseList.splice(index, 1);
                if(contractTrackPhaseList.length > 0) {
                    for(var i = 0; i < contractTrackPhaseList.length; i++) {
                        let ended = contractTrackPhaseList[i].ended;
                        let active = contractTrackPhase.active;
                        if(active) {
                            if(!ended) {
                                contractTrackPhaseList[i].active = true;
                                break;
                            } else {
                                contractTrackPhaseList[i].active = false;
                            }
                        }
                    }
                }
                self.contract.contractTrackPhaseList = Utils.merge([], contractTrackPhaseList);
            },
            changeDueDate: function (contractTrackPhase) {
                if(contractTrackPhase.absDate) {
                    contractTrackPhase.incrDays = null;
                    contractTrackPhase.dueDate = null;
                }
            },
            changeName: function (contractTrackPhase, index) {
                let self = this;
                let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                if(contractTrackPhaseList.length > 0) {
                    for(var i = 0; i < contractTrackPhaseList.length; i++) {
                        if(i != index) {
                            if(contractTrackPhaseList[i].name == contractTrackPhase.name) {
                                contractTrackPhase.name = null;
                                MsgBox.warning("阶段名称已存在");
                                return false;
                            }
                        }
                    }
                }
            },
            amountPayValue: function (contractTrackPhase) {
                let estmtAmount = this.contract.estmtAmount;
                if(estmtAmount == null) {
                    estmtAmount = 0;
                }
                let amountPayPct = contractTrackPhase.amountPayPct || 0;
                if(Utils.isNumber(amountPayPct)) {
                    contractTrackPhase.amountPay = Utils.ParseFloat(((estmtAmount * amountPayPct) / 100).toFixed(2));
                } else {
                    contractTrackPhase.amountPay = 0;
                }
                this.contract.contractTrackPhaseList = Utils.merge([], this.contract.contractTrackPhaseList);
            },
            amountPayPctValue: function (contractTrackPhase) {
                let estmtAmount = this.contract.estmtAmount;
                if(estmtAmount == null) {
                    contractTrackPhase.amountPayPct = 0;
                } else {
                    let amountPay = contractTrackPhase.amountPay;
                    if(Utils.isNumber(amountPay)) {
                        contractTrackPhase.amountPayPct = Utils.ParseFloat(((amountPay / estmtAmount).toFixed(4) * 100).toFixed(2));
                    } else {
                        contractTrackPhase.amountPayPct = 0;
                    }
                }
                this.contract.contractTrackPhaseList = Utils.merge([], this.contract.contractTrackPhaseList);
            },
            goodsDeliverCountValue: function (contractTrackPhase) {
                let estmtGoodsCount = this.contract.estmtGoodsCount;
                if(this.contract.estmtGoodsCount == null) {
                    estmtGoodsCount = 0;
                }
                let goodsDeliverCountPct = contractTrackPhase.goodsDeliverCountPct;
                if(Utils.isNumber(goodsDeliverCountPct)) {
                    contractTrackPhase.goodsDeliverCount = Utils.ParseInt((estmtGoodsCount * goodsDeliverCountPct) / 100);
                } else {
                    contractTrackPhase.goodsDeliverCount = 0;
                }
                this.contract.contractTrackPhaseList = Utils.merge([], this.contract.contractTrackPhaseList);
            },
            goodsDeliverCountPctValue: function (contractTrackPhase) {
                let estmtGoodsCount = this.contract.estmtGoodsCount;
                if(this.contract.estmtGoodsCount == null) {
                    contractTrackPhase.goodsDeliverCountPct = 0;
                } else {
                    let goodsDeliverCount = contractTrackPhase.goodsDeliverCount;
                    if(Utils.isNumber(goodsDeliverCount)) {
                        contractTrackPhase.goodsDeliverCountPct = Utils.ParseFloat(((contractTrackPhase.goodsDeliverCount / estmtGoodsCount) * 100).toFixed(2));
                    } else {
                        contractTrackPhase.goodsDeliverCountPct = 0;
                    }

                }
                this.contract.contractTrackPhaseList = Utils.merge([], this.contract.contractTrackPhaseList);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                        if(!Utils.isNoB(contractTrackPhaseList)) {
                            contractTrackPhaseList.forEach(function (item) {
                                if(!Utils.isNoB(item.wrntPeriodStartTime)) {
                                    item.wrntPeriodStartTime = item.wrntPeriodStartTime.format('yyyy-MM-dd HH:mm');
                                }
                                if(!Utils.isNoB(item.dueDate)) {
                                    item.dueDate = item.dueDate.format('yyyy-MM-dd');
                                }
                            });
                        }
                        result.type = 'info';
                        result.data = contractTrackPhaseList;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractTrackPhase.vue